import LogicaAPI from "./logicaapi";
class Right extends LogicaAPI {
  async courses(id) {
    return this.get(`/api/v1/rights/${id}/courses`);
  }
  async products(id) {
    return this.get(`/api/v1/rights/${id}/products`);
  }

  // 本番環境だとrightのスキーマに画像が設定されていてLogicaAPIが500エラーになるので使わない
  // async productRights(productId) {
  //   return this.get(`/products/${productId}/rights`);
  // }

  async rightsByRefId(refId) {
    const res = await this.get(`/api/v1/rights?id=ref:${refId}`);
    return res === null || res === void 0 ? void 0 : res[0];
  }
  async rightsByIds(ids) {
    // ids : array of int
    const idString = ids.join(",");
    return this.get(`/api/v1/rights?id=${idString}`);
  }
}
export default Right;